import { colors } from 'modules/app/styles'
import styled from 'styled-components'

export const CompanyLogo = styled.div`
  background: ${colors['blue-secondary']};
  width: 72px;
  height: 72px;
  border-radius: 72px;
  border: 3px solid ${colors['blue-100']};
  display: flex;
  align-items: center;
  justify-content: center;
`
export const MemberTabs = styled.div`
  display: flex;
  margin-bottom: 24px;
  white-space: nowrap;
  overflow: auto;
  @media (min-width: 576px) {
    overflow: unset;
  }
  width: 100%;
  a {
    color: ${colors['main-text']};
    margin-right: 24px;
    margin-bottom: 10px;
    position: relative;
    &.active {
      color: ${colors['main-blue']};
      font-weight: 600;
      &:after {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background: #0d55ff;
        margin-top: 6px;

        position: absolute;
        left: 33%;
        transform: translateX(-50%);
        bottom: -10px;
      }
    }
  }

  span {
    color: ${colors['main-text']};
    margin-right: 24px;
    margin-bottom: 10px;
    position: relative;
    &.active {
      color: ${colors['main-blue']};
      font-weight: 600;
      &:after {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background: #0d55ff;
        margin-top: 6px;

        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -10px;
      }
    }
  }
`
export const TeamCard = styled.div`
  border: 1px solid ${colors['light-blue-200']};
  background: ${colors['lightest-blue']};
  height: 100%;
  .cardheader {
    padding: 16px;
    border-bottom: 1px solid ${colors['light-blue-200']};
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 16px;
      font-weight: 600;
    }
  }
`
export const TeamUsers = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 8px;
  align-items: center;
  min-height: 70px;
  .avatar {
    margin: 7px;
  }
`
export const MemberOption = styled.div`
  background: ${colors['light-blue-100']};
  border-radius: 24px;
  display: flex;
  align-items: center;
`

